import { c as _c } from "react/compiler-runtime";
export default function CarePremium() {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="summary">안심케어 프리미엄 상품 가입<br />중개사님께 주어지는 혜택!</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h4 className="title text_blue">안심 계약서 작성</h4>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <li>{t1}<p className="desc">이실장 계약관리시스템을 활용해 <strong className="text_blue400">11여가지 공부 데이터 연동</strong>으로 계약서를 작성하실 수 있으며(멤버십 혜택) 서비스 신청 후 전문가가 추가로 꼼꼼히 검토해드려요.</p></li>;
    t3 = <h4 className="title text_primary">등기변동 사건 모니터링</h4>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <li>{t3}<p className="desc">계약일부터 잔금일까지 <strong className="text_primary400">120여가지 등기사건변동 모두 모니터</strong>하고 변동사항이 확인되면 알림톡으로 전달해드려요.</p></li>;
    t5 = <h4 className="title text_violet">법률 상담 서비스</h4>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <strong className="text_violet400">​부동산 전문 변호사님과 상담하고 빠르게 해결</strong>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <li>{t5}<p className="desc">계약 당사자간 분쟁 등 계약 중 발생하는 돌발 이슈도{" "}{t6}해요.<small>* 청약인수기준 및 보통약관 충족 시</small></p></li>;
    t8 = <h4 className="title text_green">권리보험 서비스</h4>;
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <strong className="text_green400">권리보험</strong>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <>{t0}<ul className="list_card">{t2}{t4}{t7}<li>{t8}<p className="desc">매도인이 진짜 집주인이 아닌 경우​ 혹은 고객이 소유권을 취득한 이후에도 소유권을 잃게 되는 경우​{" "}{t9}을 통해 고객의 실손금을 보상해 드려요.<small>* ​보상기준은 보험상품의 보통약관 및 서비스 신청 조건에 따름</small></p></li></ul></>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  return t10;
}